import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react-lite';
import {FormattedMessage} from 'react-intl';
import {AppContext} from '../../../store';
import EventApi from '../../../services/api/eventApi';
import {handleCheckInFromAttendees} from '../../../services/helpers/checkInHelper';
import './AttendeeBtnsMore.scss';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import reserveATable
    from "../../invitations/InvitationFormRespond/ReserveATable";
import {IconButton, Menu, MenuItem} from "@mui/material";
import styles from './AttendeeBtnsMore.module.scss'

const ITEM_HEIGHT = 48;
const AttendeeBtnsMore = observer(props => {
    const {attendee, user} = props;
    const {participantStore, eventStore, modalStore} = React.useContext(AppContext);
    const {eventDetails} = eventStore;
    const {tags} = participantStore;
    const [openPopup, setOpenPopup] = React.useState(false);
    const canCheckIn = eventDetails && eventDetails.me.checkInAdmin && !eventDetails.isFinished;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleCheckIn = (attendeeDetails, id) => {
        setOpenPopup(false);
        handleCheckInFromAttendees(attendeeDetails, id);
    };

    const handleBadgePrint = (attendeeDetails, id) => {
        setOpenPopup(false);
        EventApi.getParticipantDetailsForOrganizer(attendeeDetails.eventId, attendeeDetails.id).then(res => {
            handleCheckInFromAttendees(res, id, 'printBadgeForced');
        });
    };

    const handlePreBookedMeeting = (attendeeDetails) => {
        setOpenPopup(false);
        modalStore.open('preBookedMeetingModal', {attendee: attendeeDetails});
    }


    const handleReserveATable = (attendeeDetails) => {
        setOpenPopup(false);
        modalStore.open('reserveATableModal', {attendee: attendeeDetails});
    }

    const handleShowAgenda = (attendeeDetails) => {
        setOpenPopup(false);
        modalStore.open('showAgendaModal', {attendee: attendeeDetails});
    }
    if (!canCheckIn && !eventDetails.me.organizer && !eventDetails.me?.rights?.onbehalfmeeting && !eventDetails.me?.rights?.reserveatable) {
        //return null;
    }

    return eventDetails?.id === attendee?.eventId ? (
        <div className={props.className}>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon/>
            </IconButton>
            <Menu
                className={styles.attendeeMoreMenu}
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        style: {
                            maxHeight: ITEM_HEIGHT * 4.5,
                            width: '20ch',
                        },
                    },
                }}
            >
                {(canCheckIn) && (
                    <MenuItem className={styles.menuItem} key={'checkIn'}
                              onClick={() => handleCheckIn(attendee, eventDetails?.id)}>
                        <FormattedMessage id="attendee.btn.checkIn"/>
                    </MenuItem>
                )}
                {(eventDetails.me.organizer) && (
                    <MenuItem className={styles.menuItem} key={'printBadge'}
                              onClick={() => handleBadgePrint(attendee, eventDetails?.id)}>
                        <FormattedMessage id="attendee.btn.printBadge"/>
                    </MenuItem>
                )}
                {(eventDetails.me?.rights?.onbehalfmeeting) && (
                    <MenuItem className={styles.menuItem} key={'preBookedMeeting'}
                              onClick={() => handlePreBookedMeeting(attendee, eventDetails?.id)}>
                        <FormattedMessage id="attendee.btn.preBookMeeting"/>
                    </MenuItem>
                )}
                {(eventDetails.me?.rights?.onbehalfmeeting) && (
                    <MenuItem className={styles.menuItem} key={'showAgenda'}
                              onClick={() => handleShowAgenda(attendee, eventDetails?.id)}>
                        <FormattedMessage id="attendee.btn.showAgenda"/>
                    </MenuItem>
                )}
                {(eventDetails.me?.rights?.reserveatable && user.id === attendee.userId) && (
                    <MenuItem className={styles.menuItem} key={'reserveATable'}
                              onClick={() => handleReserveATable(attendee, eventDetails?.id)}>
                        <FormattedMessage id="attendee.btn.reserveATable"/>
                    </MenuItem>
                )}

            </Menu>
        </div>
    ) : null;
});

AttendeeBtnsMore.propTypes = {
    attendee: PropTypes.oneOfType([PropTypes.object]),
    className: PropTypes.string,
};

AttendeeBtnsMore.defaultProps = {
    attendee: {},
};

export default AttendeeBtnsMore;
